module.exports = __webpack_public_path__ + "static/media/safar.53676804.jpg";